import { colors, size } from '@styles/theme'
import useYesOrNo from '@hooks/useYesOrNo'
import styled from '@emotion/styled'
import HiddenYesOrNo from './HiddenYesOrNo'
import { Button } from '@mui/material'
import useModalContext from '@contexts/modalContext'

const Container = styled.div`
  height: 100%;
  width: 100%;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 ${size(2)};
  padding-top: 25vh;
`

const UnhideButton = styled(Button)`
  border-radius: 100px;
  color: white;
  margin-top: ${size(2)};
  margin-right: ${size(1)};
`

const SubscribeButton = styled(Button)`
  border-radius: 100px;
  color: white;
  margin-top: ${size(2)};
`

const HiddenMessage = styled.p`
  line-height: ${size(3.5)};
  max-width: 85svw;
  margin-left: auto;
  margin-right: auto;
`

const HiddenDisplay = () => {
  const [isHideDialogOpen, openHideDialog, closeHideDialog] = useYesOrNo('hide-yourself-confirmation')
  const { subscriptionFeature } = useModalContext()

  return (
    <Container>
      <HiddenYesOrNo
        isOpen={isHideDialogOpen}
        setClosed={closeHideDialog}
      />
      <h1>You are hidden.</h1>
      <HiddenMessage>Keep using the map and grid while hidden by supporting the application ❤️</HiddenMessage>
      <UnhideButton
        onClick={openHideDialog}
        variant='outlined'
        style={{ borderColor: colors.statusColors.right_now('light'), }}>
        Unhide
      </UnhideButton>
      <SubscribeButton
        onClick={() => subscriptionFeature.open()}
        variant='contained'
        style={{ backgroundColor: colors.statusColors.right_now('primary'), }}>
        Get Supporter +
      </SubscribeButton>
    </Container>
  )
}

export default HiddenDisplay
